// HOME
const home = {
  description: `
    <p>Welcome to <em>Radiance Dental</em>, located in the heart of Reading, Massachusetts, just 12 miles north of Boston, with convenient parking and access to public transportation.  We are proud to be voted one of <em>Boston’s Top Dentists</em> by <em>Boston Magazine</em>.</p>

    <p>Our caring and knowledgeable staff is led by Dr. Li-An Su, and dedicated to providing modern dental care in the most gentle, comfortable, and relaxing manner.  We understand that trust is the most precious thing in a relationship, and we strive to earn your trust.</p>
  `,
  subcategories: [
    {
      title: `Family Dentistry`,
      description: `
        <p>Radiance Dental is dedicated to serving patients of all ages.  We equip our office with the latest high-tech instruments and provide a full range of dental services to all members of your family.  We have a multi-cultural staff able to communicate with patients in both English and Chinese.</p>
      `,
    },
    {
      title: `Esthetic Dentistry`,
      description: `
        <p>We want to give you something to smile about!  A natural-looking beautiful smile is our goal for every patient.</p>
      `,
    },
    {
      title: `Digital Dentistry`,
      description: `
        <p>Dentistry has evolved in this digital age.  Digital scanners make crowns and other dental prosthesis that fit better, and the process easier and more comfortable.  No more goopy impression materials in the mouth!</p>
      `,
    },
    {
      title: `Connecting Oral Health with Overall Wellness`,
      description: `
        <p>Did you know that periodontal disease is a cause of heart disease and diabetes? Or that oral cancer can be caused by viruses?  Or that sleep apnea can cause bruxism, the clenching and grinding of teeth?  What is happening inside our mouths has intimate links with the rest of the body. At Radiance Dental, our dental professionals not only want you to have a healthy mouth, but also a healthy body.</p>
      `,
    },
    {
      title: `Staying Safe from Covid`,
      description: `
        <p>At Radiance Dental, we take everyone’s safety seriously.  From medical grade air purifiers that filter over 99.9% of viral-size particles (read about <a href=”https://surgicallycleanair.com/jade/” target=”_blank”>Jade by Surgically Clean Air here</a>.) to patient screening, frequent surface disinfecting, and superior infection control protocols, we deliver dental services and peace of mind.</p>
      `,
    },
    {
      title: `Green Dentistry`,
      description: `
        <p>Radiance Dental aims to be as earth-friendly as possible in our choices of materials and adaptation of recycling programs. </p>
      `,
    },
  ],
};

// SERVICES
const periodontal = {
  image: '1.jpg',
  imageTitle: 'Radiance Dental Waiting Room',
  imageAlt: 'Radiance Dental Waiting Room',
  title: 'Periodontal Treatment',
  description: `
    <p>Periodontal disease (gum disease) is one of the leading causes of heart disease and diabetes, all of which trigger chronic inflammation of bodily tissues.  It is estimated that over 40% of American adults have some form of periodontal disease, which begins with gingivitis (the inflammation of gums) and can progress to serious destruction of the ligaments and bones supporting our teeth, causing teeth to loosen and fall out. This is why we emphasize in the diagnosis and treatment of periodontal disease. The chief cause of periodontal disease is bacteria, however, there are also hereditary factors that affect the severity of the disease in each person.</p>
    <p>How do I know if I have periodontal disease?</p>
    <p>During a complete dental exam, Dr. Su or our experienced hygienist will take measurements of the gums to determine the depth of periodontal pockets around each tooth.  Healthy gums typically have measurements between 1 to 3 mm with no bleeding.  Increased measurements and/or bleeding indicate the presence of periodontal disease.</p>
  `,
  subcategories: [
    {
      title: `Scaling and root planing`,
      description: `
        <p>Scaling and root planing (deep cleaning) is the first stage of treating periodontal disease.  During this treatment, your dentist or hygienist numbs up the treatment areas and removes the bacterial build-up (plaque and calculus) as well as unhealthy lining of gums to allow the gums to regenerate. Some individuals only need to have scaling and root planing once, while others may need it every few years.  Your dentist can make the recommendations for you.</p>
      `,
      img: '39.jpg',
      imgTitle: 'Reviewing Dental XRays',
      imgAlt: 'Reviewing Dental XRays',
    },
    {
      title: `Periodontal Maintenance`,
      description: `
        <p>Periodontal Maintenance is the maintenance stage following scaling and root planing.  During your visit, bacterial build-up (plaque and calculus) is removed from above and below the gum line in order to keep the gums in a healthy condition. It is typically recommended to have periodontal maintenance every three months for those with a history of periodontal maintenance.</p>
      `,
      img: '40.jpg',
      imgTitle: 'Dr. Su Performing Routine Dental Cleaning',
      imgAlt: 'Dr. Su Performing Routine Dental Cleaning',
    },
    {
      title: `Routine Dental Cleanings`,
      description: `
        <p>Routine Dental Cleanings is recommended for individuals with healthy teeth and gums to maintain their oral health.  Even though most people get two cleanings a year, some people may benefit from more frequent cleanings depending on their gum condition.  Your dental professionals can recommend the frequency to you.</p>
      `,
      img: '24.jpg',
      imgTitle: '3D render of lower jaw and teeth for dentist',
      imgAlt: '3D render of lower jaw and teeth for dentist',
    },
    {
      title: `Do I have periodontal disease?`,
      description: `<p>Request a complete exam appointment by calling <a href="tel:+17814396267">(781) 439-6267</a> or texting <a href="sms:+17813156183">(781) 315-6183</a>.</p>`,
      img: '38.jpg',
      imgTitle: 'Woman thinking about visiting dentist',
      imgAlt: 'Woman thinking about visiting dentist',
    },
  ],
};


const esthetic = {
  image: '2.jpg',
  imageTitle: 'Radiance Dental Front Desk',
  imageAlt: 'Radiance Dental Front Desk',
  title: 'Esthetic Dentistry',
  description: ``,
  subcategories: [
    {
      title: `White Composite Fillings`,
      description: `
        <p>White Composite Fillings are the standard in restoring decayed or chipped teeth.  They can be made artistically to mimic natural tooth structure.  At Radiance Dental, we do not place amalgam (silver) fillings due to its negative impact on the environment and ability to cause tooth fractures.</p>
      `,
      img: '18.jpg',
      imgTitle: 'Model of healthy teeth and jaws',
      imgAlt: 'Model of healthy teeth and jaws',
    },
    {
      title: `Bondings`,
      description: `
        <p>Bondings utilize composite material to change the shape of teeth or close the spaces between teeth.  It is the most conservative way to close gaps between teeth or cover exposed root surfaces because it does not require removing any tooth structure.</p>
      `,
      img: '27.jpg',
      imgTitle: 'Woman flossing in front of bathroom mirror',
      imgAlt: 'Woman flossing in front of bathroom mirror',
    },
    {
      title: `Veneers`,
      description: `
        <p>Veneers are thin porcelain facades that change the shape and color of anterior teeth.  They can be used to close spaces or mask discoloration.</p>
      `,
      img: '35.jpg',
      imgTitle: 'Woman smiling with healthy teeth',
      imgAlt: 'Woman smiling with healthy teeth',
    },
    {
      title: `Crowns`,
      description: `
        <p>Crowns are protective jackets that cover teeth when fillings can no longer hold a tooth together.  A crown can prevent a tooth with a <em>fracture</em> line from split further and give a tooth with old dark fillings a beautiful appearance.  Today, technology allows us to offer our patients natural-looking crowns that can withstand the pressure of chewing and grinding.</p>
      `,
      img: '15.jpg',
      imgTitle: 'Partial model of jaws and teeth',
      imgAlt: 'Partial model of jaws and teeth',
    },
    {
      title: `Bridges`,
      description: `
        <p>Bridges are one way of replacing missing teeth.  They are basically three or more units of connecting crowns.</p>
      `,
      img: '22.jpg',
      imgTitle: 'Partial model of jaws and teeth with missing canine',
      imgAlt: 'Partial model of jaws and teeth with missing canine',
    },
    {
      title: `Teeth Whitening`,
      description: `
        <p>Teeth Whitening is a great way to achieve a bright smile.  While many over-the-counter products are effective, some of them contain ingredients that can cause sensitivity or harm to the teeth.  We partner with <a href="https://www.ultradent.com/" target="_blank">UltraDent</a> to create customized whitening trays for our patients that are safe, comfortable, and effective.</p>
      `,
      img: '36.jpg',
      imgTitle: 'Woman smiling outside in sun',
      imgAlt: 'Woman smiling outside in sun',
    },
  ],
};

const implant = {
  image: '6.jpg',
  imageTitle: 'Radiance Dental Advanced 3D Dentistry Technology',
  imageAlt: 'Radiance Dental Advanced 3D Dentistry Technology',
  title: 'Implants and Dentures',
  description: ``,
  subcategories: [
    {
      title: `Replacing a Single Missing Tooth`,
      description: `
        <p>In the 21st century, implants have become the most common way to replace single missing teeth.  At Radiance Dental, Dr. Su works with a network of experienced surgeons in the area to provide her patients highly successful implant services. Implants can replace a single tooth, or an entire arch, however, they are not for everyone.</p>
      `,
      img: '21.jpg',
      imgTitle: 'Model of bottom jaw with fake tooth',
      imgAlt: 'Model of bottom jaw with fake tooth',
    },
    {
      title: `How do I know if I am a candidate for implants?`,
      description: `
        <p>Call <a href="tel:+17814396267">(781) 439-6267</a> or text <a href="sms:+17813156183">(781) 315-6183</a> to set up a consultation appointment.</p>
      `,
      img: '37.jpg',
      imgTitle: 'Woman smiling to herself in a mirror',
      imgAlt: 'Woman smiling to herself in a mirror',
    },
    {
      title: `Dentures`,
      description: `
        <p>Dentures are an economical way of replacing multiple missing teeth.  Today’s dentures can be made with flexible thin materials that do not damage existing teeth.  They can also be made to incorporate <em>implants</em> to achieve maximal retention. In the cases when there is no adequate bone to support dentures, <em>implant-supported overdentures (two-on-one, four-on-one)</em> have become the best way to restore a beautiful, functional smile.  You can comfortably bite into an apple, or start eating ribs again.</p>
      `,
      img: '16.jpg',
      imgTitle: 'Model of bottom dentures',
      imgAlt: 'Model of bottom dentures',
    },
    {
      title: `How do I know if I am a candidate for implant-supported overdentures?`,
      description: `
        <p>Call <a href="tel:+17814396267">(781) 439-6267</a> or text <a href="sms:+17813156183">(781) 315-6183</a> to set up a consultation appointment.</p>
      `,
      img: '34.jpg',
      imgTitle: 'Woman with thoughtful expression',
      imgAlt: 'Woman with thoughtful expression',
    },
  ],
};

const pediatric = {
  image: '4.jpg',
  imageTitle: 'Radiance Dental Dentist Chair in Sunny Reading, MA',
  imageAlt: 'Radiance Dental Dentist Chair in Sunny Reading, MA',
  title: 'Pediatric Dentistry',
  description: `
    <p>Children are our future, and their oral health will affect their overall health and development.  The American Academy of Pediatric Dentistry recommends that children start visiting dentists by age one.  We make children’s first visits fun so they will love brushing their teeth and visiting the dentist.  Not only do dentists diagnose early signs of tooth decay, they can help pick up signs of airway obstruction and developmental issues and give proper guidance for early intervention.</p>
  `,
  subcategories: [
    {
      title: `Sealants`,
      description: `
        <p>Sealants are protective coatings placed on the chewing surfaces of posterior teeth to prevent tooth decay in the uneven grooves on these surfaces.  Sealants can be placed on both adult and baby teeth.  We use only BPA-free materials in making sealants.  Sealants are only for teeth with no cavities. Due to natural wear and tear, sealants may need to be re-applied after a few years.  Your dentist can let you know if any sealants need replacement.</p>
      `,
      img: '32.jpg',
      imgTitle: 'Radiance Dental teeth cleaning equipment',
      imgAlt: 'Radiance Dental teeth cleaning equipment',
    },
    {
      title: `White Fillings`,
      description: `
        <p>White Fillings are made out of BPA-free materials to restore teeth with cavities.  They are natural-looking and more conservative than other materials, but need to be placed with great care for the best results.  At Radiance Dental, we do not use silver amalgams due to its mercury content and negative impact to our bodies and environment.</p>
      `,
      img: '31.jpg',
      imgTitle: 'Dentistry patient being examined',
      imgAlt: 'Dentistry patient being examined',
    },
    {
      title: `Fluoride Treatment`,
      description: `
        <p>Fluoride Treatment is the best way to strengthen teeth against tooth decay/cavities.  Fluoride is a naturally occurring mineral and comes in different forms.  For people with high risk of tooth decay, prescription fluoride toothpaste, topical fluoride gel or varnish, and silver diamine fluoride, are all ways to prevent teeth from getting cavities.  Consult your dental professionals if you need fluoride supplements.</p>
      `,
      img: '25.jpg',
      imgTitle: 'Child brushing teeth',
      imgAlt: 'Child brushing teeth',
    },
    {
      title: `Orthodontic Evaluation`,
      description: `
        <p>Orthodontic Evaluation is an integral part of our oral exam.  As children grow, crowding of teeth, overbite, underbite, open bite, mouth-breathing, narrow airways, and oral habits will all affect their facial development, breathing, speech, posture, sleep quality, and overall health. Improper bite can lead to premature wear of teeth and TMJ problems. Because it is important to diagnose a condition early, children should visit a dentist every 6 months starting age one so dentists can make recommendations in a timely manner, should early orthodontic intervention be necessary.</p>
      `,
      img: '26.jpg',
      imgTitle: 'Young girl with braces smiling',
      imgAlt: 'Young girl with braces smiling',
    },
  ],
};

const other = {
  image: '5.jpg',
  title: 'Other Services',
  imageTitle: 'Radiance Dental Dentist Chair and Office',
  imageAlt: 'Radiance Dental Dentist Chair and Office',
  subcategories: [
    {
      title: `Dental Emergency`,
      description: `
        <p>Toothaches never sleep.  Lost fillings and fracture can cause biting discomfort and lead to infection. Crowns that fall off teeth can expose the inside of a tooth and cause sensitivity and decay.</p>
        <p>Our doctor is on call after office hours to assist our patients in their times of need.</p>
        <p>Call <a href="tel:+17814396267">(781) 439-6267</a> or text <a href="sms:+17813156183">(781) 315-6183</a>.</p>
      `,
      img: '30.jpg',
      imgTitle: 'Dentistry patient having her teeth cleaned by a dentist and a dental assistant',
      imgAlt: 'Dentistry patient having her teeth cleaned by a dentist and a dental assistant',
    },
    {
      title: `Night guards`,
      description: `
        <p><em>Bruxism</em> (involuntary teeth grinding or clenching) is a major cause of <em>TMJ pain</em> and tooth <em>fractures</em>.  It is induced by stress and <em>sleep apnea</em>, which is a serious medical condition.  While it is difficult to fully treat bruxism, we can effectively protect the teeth and reduce TMJ pain by wearing a customized night guard.</p>
        <p>Dr. Su can help diagnose the presence of bruxism and sleep apnea and help treat the conditions.</p>
        <p>Call <a href="tel:+17814396267">(781) 439-6267</a> or text <a href="sms:+17813156183">(781) 315-6183</a>.</p>
      `,
      img: '33.jpg',
      imgTitle: 'Young girl and mother sleeping',
      imgAlt: 'Young girl and mother sleeping',
    },
    {
      title: `Removable Orthodontic Retainers`,
      description: `
        <p>Lost a retainer?  Yes, we can make another one for you. It is important to wear your orthodontic retainers after braces and Invisalign treatments because your teeth can move throughout the life.</p>
      `,
      img: '24.jpg',
      imgTitle: 'Partial model of jaws and teeth',
      imgAlt: 'Partial model of jaws and teeth',
    },
    {
      title: `Long-Term Fixed Retainers`,
      description: `
        <p>Have you ever wanted to never wear the removable retainers and not have your teeth move?  The answer is to have a fixed retainer behind your teeth.  Talk to your dental professional to see if you are a candidate for long-term fixed retainers.</p>
      `,
      img: '28.jpg',
      imgTitle: 'Dental assistant setting up sterile dentist tools',
      imgAlt: 'Dental assistant setting up sterile dentist tools',
    },
    {
      title: `Adult Fluoride Treatment`,
      description: `
        <p>A naturally occurring mineral, fluoride is the best substance to re-mineralize and strengthen teeth, and prevent tooth decay. Recently, the FDA has approved <em>silver diamine fluoride</em> (10% silver, 38% fluoride) as a topical medication to stop the development of cavities.  This presents as a great news for tooth decay that cannot be treated. In addition to stopping decay, SDF can also <em>desensitize</em> teeth. Ask your dental professional if it is the right choice for you.</p>
      `,
      img: '29.jpg',
      imgTitle: 'Man examining teeth in mirror in dentist office',
      imgAlt: 'Man examining teeth in mirror in dentist office',
    },
  ],
};

// MEET DR SU
const su = {
  description: `
    <p>Dr. Li-An Su was born in Taiwan.  As a teenager, she moved to Southern California with her family. Because of her bi-cultural background, she speaks both English and Mandarin Chinese fluently. Growing up, she has contemplated a career in many fields: art, music, science, medicine, environmental conservation, and horticulture, but eventually settled on dentistry due to its unique quality of combining art and medicine in practice.  She received a Bachelor of Arts degree in Biology from <em>University of California, Los Angeles</em>.  She then attended <em>Tufts University School of Dental Medicine</em> and graduated with a D.M.D. degree.  She is a member of the <em>American Dental Association, Massachusetts Dental Society</em>, and the prestigious <em>Spear Study Club</em>. She was voted as a <em>Boston’s Top Dentist</em> in the Boston Magazine survey in 2019 for esthetic dentistry.</p>
    <p>While attending Tufts University in Boston, Dr. Su fell in love with New England and decided to practice here.  She opened Radiance Dental in Reading, MA, in 2004, because of its wonderful people and surrounding communities.</p>
    <p>In over 20 years of her dental practice, Dr. Su has worked with people from all walks of life, giving her the confidence and ability to work with children, adults, special needs patients, and patients from different cultural backgrounds.</p>
    <p>Outside of dentistry, Dr. Su loves gardening, traveling, learning about new things, and staying fit. She practices yoga and incorporates the calming breathing techniques of yoga into her dental practice. On a sunny day, she can often be found digging in her garden.</p>
  `,
};

const services = {
  periodontal,
  esthetic,
  implant,
  pediatric,
  other,
};

const text = {
  home,
  services,
  su,
};

export default text;
